import { IOptions } from '@portal/app/dashboard/export-native-dashboard-data/models/IExportConfig';

export function isParentClientHiddenExportDimensionValue(
  value: string
): boolean {
  if (value === 'campaign' || value === 'adset_name') {
    return true;
  }
  if (/^derived_dimen_[1-5]$/.test(value)) {
    return true;
  }
  const first = value.split(',')[0]?.trim();
  return first === 'derived_dimen_1';
}

export function filterParentClientHiddenExportDimensions(
  dimensions: IOptions[]
): IOptions[] {
  return dimensions.filter(
    (d) => !isParentClientHiddenExportDimensionValue(d.value)
  );
}
